module.exports = __webpack_public_path__ + "assets/sun.5856437f.svg";